import { Component, ChangeDetectionStrategy, ViewEncapsulation, input, computed, inject, Input } from '@angular/core';
import { IOnboardingActive } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';
import { AppTextService } from '@fi-shared/app-text';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Component({
    selector: 'fi-onboarding-progress-bar',
    templateUrl: './fi-onboarding-progress-bar.component.html',
    styleUrl: './fi-onboarding-progress-bar.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-progress-bar' },
    standalone: false,
})
export class FiOnboardingProgressBarComponent {
    public totalStepsCount = input.required<number>();
    public completedStepsCount = input.required<number>();
    public completionDate = input<Date | string>();
    @Input() isSystemNotificationsMode = false;

    private readonly appTextService = inject(AppTextService);
    private readonly fiFormatDateService = inject(FiFormatDateService);

    protected completedFraction = computed(() => {
        const totalStepsCount = this.totalStepsCount();
        if (totalStepsCount === 0) {
            return 100; // consider as completed
        }
        return Math.round((this.completedStepsCount() / totalStepsCount) * 100);
    });
    protected onboardingCompleted = computed(() => this.completedFraction() === 100);
    protected completedStepsCounterLabel = computed(() => {
        if (!this.isSystemNotificationsMode) {
            return `${this.completedStepsCount()}/${this.totalStepsCount()} ${this.appTextService.get('common.steps')}`;
        }
        return `${this.completedStepsCount()}/${this.totalStepsCount()}`;
    });
    protected completionDateLabel = computed(() => {
        return `${this.appTextService.get('common.completed')}: ${this.fiFormatDateService.formatDate(this.completionDate(), 'date')}`;
    });
}
